import { useEffect, useState } from "react";
import { RouteError } from "@/components/RouteError";
import { RouteLoading } from "@/components/ui/RouteLoading";
import { reloadForNewBuild } from "@/lib/stale-build";

/**
 * Stands in for a page whose chunk a deploy removed while this tab was open.
 * Reloads to the new build; falls back to the route error if it just tried.
 */
export function StaleBuildReload() {
  const [reloadBlocked, setReloadBlocked] = useState(false);

  useEffect(() => {
    if (!reloadForNewBuild()) setReloadBlocked(true);
  }, []);

  return reloadBlocked ? <RouteError /> : <RouteLoading />;
}
